import React, { useEffect, useState } from "react";
import {
  setUserSettings,
  createSubscriptionRustFreeTrial,
} from "../services/api";
import Auth from "../services/auth";
import spinnerFrame01 from "../../images/loading-indicator/frame_01.webp";
import warning from "../../images/not-supported/icon.webp";
import moment from "moment/moment";
import auth0 from "auth0-js";
import { userPlan } from "../user";

const auth = new auth0.WebAuth({
  domain: process.env.AUTH0_DOMAIN,
  clientID: process.env.AUTH0_CLIENT_ID,
  redirectUri: window.location.origin,
  responseType: "token id_token",
  scope: "openid profile email",
});

const FreeTrialRust = () => {
  const userPlanId = userPlan();
  const isFreeUser = userPlanId === "NYA-FREE";

  const isClassicUser = [
    "NYA-UNLIMITED-MONTHLY",
    "NYA-UNLIMITED-YEARLY",
    "NYA-UNLIMITEDV2-YEARLY",
    "NYA-UNLIMITEDV2-MONTHLY",
  ].includes(userPlanId);
  const isPatronUser = ["NYA-UNLIMITED-YEARLY-PATRON"].includes(userPlanId);

  const isRustUser = [
    "NYA-UNLIMITED-YEARLY-RUST",
    "NYA-UNLIMITEDV2-YEARLY-RUST",
  ].includes(userPlanId);
  const [promoIsAvailable, setPromoIsAvailable] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [loadingMessage, setLoadingMessage] = useState("Loading...");
  const [countdown, setCountdown] = useState(3);
  const [activeTab, setActiveTab] = useState("signUp"); // Track active tab (signIn or signUp)
  const [email, setEmail] = useState("");
  const [currentEmail, setCurrentEmail] = useState(""); // For sign-in only
  const [password, setPassword] = useState("");
  const [firstName, setFirstName] = useState(""); // For sign-up only
  const [error, setError] = useState("");
  const [freeTrialState, setFreeTrialState] = useState("initial");
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [confirmPassword, setConfirmPassword] = useState("");
  const [acceptEmails, setAcceptEmails] = useState(false);
  const [acceptEmailsAlready, setAcceptEmailsAlready] = useState(false);
  const [selectedConcertAlready, setSelectedConcertAlready] = useState("");

  const [selectedConcert, setSelectedConcert] = useState("");
  const isFormValid =
    firstName.trim() !== "" &&
    selectedConcert.trim() !== "" &&
    email.trim() !== "" &&
    password.trim() !== "";

  const isSecondFormValid = currentEmail.trim() !== "" && email.trim() !== "";

  // Add this array for the dropdown options
const concertOptions = [
  "Jun 18 - Rättvik, Sweden - Dalhalla",
  "Jun 20 - Bergen, Norway - Bergenhus Fortress",
  "Jun 22 - Copenhagen, Denmark - 10-Øren",
  "Jun 26 - Dublin, Ireland - Malahide Castle",
  "Jun 30 - Brussels, Belgium - Brussels Palace Open Air, Palace Square",
  "Jul 01 - Groningen, Netherlands - Drafbaan Stadspark",
  "Jul 03 - Berlin, Germany - Waldbühne",
  "Jul 04 - Mönchengladbach Germany - Sparkassenpark",
  "Jul 06 - Montreux, Switzerland - Montreux Jazz Festival",
  "Jul 08 - Stuttgart, Germany - Canstatter Wasen",
  "Jul 11 - London, UK - BST Hyde Park",
  "Jul 13 - Paris, France - Adidas Arena",
  "Aug 8 - Charlotte, NC - PNC Music Pavilion",
  "Aug 10 - Richmond, VA - Allianz Amphitheater at Riverfront",
  "Aug 13 - Detroit, MI - Pine Knob Music Theatre",
  "Aug 15 - Cleveland, OH - Blossom Music Center",
  "Aug 17 - Toronto, ON - Budweiser Stage",
  "Aug 19 - Toronto, ON - Budweiser Stage",
  "Aug 21 - Gilford, NH - BankNH Pavilion",
  "Aug 23 - New York, NY - Jones Beach",
  "Aug 24 - Bethel, NY - Bethel Woods",
  "Aug 27 - Chicago, IL - Northerly Island",
  "Aug 29 - Milwaukee, WI - BMO Pavilion",
  "Sep 01 - Denver, CO - Fiddler’s Green Amphitheatre",
  "Sep 05 - George, WA - The Gorge",
  "Sep 06 - Vancouver, BC - Deer Lake Park",
  "Sep 08 - Vancouver, BC - Deer Lake Park",
  "Sep 10 - Bend, OR - Hayden Homes Amphitheater",
  "Sep 12 - Mountain View, CA - Shoreline Amphitheater",
  "Sep 15 - Los Angeles, CA - Hollywood Bowl",
];
  useEffect(() => {
    const checkAvailability = async () => {
      const isAvailable = true; // Simulate promo availability
      setPromoIsAvailable(isAvailable);
      setIsLoading(false);
    };
    checkAvailability();
  }, []);

  useEffect(() => {
    if (freeTrialState === "Ok" && countdown > 0) {
      const timer = setTimeout(() => setCountdown(countdown - 1), 1000);
      return () => clearTimeout(timer); // Cleanup the timer
    } else if (freeTrialState === "Ok" && countdown === 0) {
      window.location.href = "about-rust";
    }
  }, [freeTrialState, countdown]);

  const handleFreeTrial = (userInfo) => {
    const emailDB =
      (userInfo.user_metadata && userInfo.user_metadata.customEmail) ||
      userInfo.email;
    const userInfoT = {
      concertAttended: selectedConcert,
    };
    setIsLoading(true);
    setLoadingMessage(
      "Please wait a moment while we activate your subscription..."
    );
    createSubscriptionRustFreeTrial(userInfoT)
      .then((res) => {
        setIsAuthenticated(true);
        setIsLoading(false);
        setFreeTrialState("Ok");
      })
      .catch((err) => {
        setFreeTrialState("Fail");
        setIsLoading(false);
      });
  };
  // Update handleSignIn
  const handleSignIn = (e) => {
    e?.preventDefault();
    setError("");
    setIsLoading(true);
    setLoadingMessage("Signing in...");

    auth.client.login(
      {
        realm: "Username-Password-Authentication",
        username: email,
        password: password,
      },
      (err, authResult) => {
        if (err) {
          setError(err.description || "An error occurred during sign-in.");
          setIsLoading(false);
          return;
        }

        // Get user info and set local storage
        auth.client.userInfo(authResult.accessToken, (err, user) => {
          if (err) {
            setError("Could not get user information");
            setIsLoading(false);
            return;
          }

          // Set required local storage items
          localStorage.setItem("ade:id-token", authResult.idToken);
          localStorage.setItem("ade:orastream-token", authResult.accessToken);
          localStorage.setItem(
            "ade:should-display-mailing-list-modal",
            "false"
          );
          localStorage.setItem("ade:temp-token", authResult.accessToken);

          // Format user info as needed
          const userInfo = {
            email: user.email,
            name: user.name || user.email,
            app_metadata: {},
            clientId: process.env.AUTH0_CLIENT_ID,
            created_at: new Date().toISOString(),
            email_verified: false,
            identities: [
              {
                user_id: user.sub,
                provider: "auth0",
                connection: "Username-Password-Authentication",
                isSocial: false,
              },
            ],
            nickname: user.nickname || user.email.split("@")[0],
            picture:
              user.picture || `https://s.gravatar.com/avatar/${user.sub}`,
            sub: `auth0|${user.sub}`,
            updated_at: new Date().toISOString(),
            user_id: `auth0|${user.sub}`,
            user_metadata: {
              firstName: user.given_name || user.name?.split(" ")[0] || "",
              verification_email_sent: true,
            },
          };

          localStorage.setItem("ade:user-info", JSON.stringify(userInfo));
          localStorage.setItem("ade:uuid", user.sub);
          setUserSettings({
            type: "cdc_newsletter",
            values: { subscribed: acceptEmails },
          });
          handleFreeTrial(userInfo);
        });
      }
    );
  };

  const sendEmailToDB = (e) => {
    e?.preventDefault();
    setError("");
    setIsLoading(true);
    setLoadingMessage("Sending email...");
    if (!currentEmail) {
      setError("Please enter your email");
      setIsLoading(false);
      return;
    }
  };

  // Update handleSignUp
  const handleSignUp = (e) => {
    e?.preventDefault();
    setError("");

    if (
      !firstName ||
      !email ||
      !password ||
      !confirmPassword ||
      !selectedConcert
    ) {
      setError("Please fill out all fields");
      return;
    }

    if (password !== confirmPassword) {
      setError("Passwords do not match");
      return;
    }

    if (!isFreeUser && (isClassicUser || isPatronUser || isRustUser)) {
      window.displayWarningMessage("free-trial-rust");
      setIsLoading(false);
      return;
    }
    setIsLoading(true);
    setLoadingMessage("Creating account...");
    auth.signup(
      {
        connection: "Username-Password-Authentication",
        email,
        password,
        user_metadata: { firstName },
      },
      (err) => {
        if (err) {
          console.log(err.code);
          if (err.code == "user_exists") {
            window.displayWarningMessage("free-trial-rust");
            setIsLoading(false);
            return;
          } else {
            setError(err.description || "An error occurred during sign-up.");
            setIsLoading(false);
            return;
          }
        }

        // After successful signup, automatically sign in
        handleSignIn();
      }
    );
  };

  const renderSignInForm = () => {
    return (
      <div className="signIn">
        {activeTab === "signUp" ? (
          <div className="form">
            <h3>
              Just enter your name, email and password below, and you are good
              to go!
            </h3>
            <div className="form-group">
              <label>First Name</label>
              <input
                type="text"
                value={firstName}
                onChange={(e) => setFirstName(e.target.value)}
                placeholder="Enter your first name"
                required
              />
            </div>
            <div className="form-group">
              <label>Concert Attended</label>
              <select
                className="concert-dropdown"
                value={selectedConcert}
                onChange={(e) => setSelectedConcert(e.target.value)}
                required
              >
                <option value="" disabled>
                  Select the concert you attended
                </option>
                {concertOptions.map((concert, idx) => (
                  <option key={idx} value={concert}>
                    {concert}
                  </option>
                ))}
              </select>
            </div>
            <div className="form-group">
              <label>Email</label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter your email"
                required
              />
            </div>
            <div className="form-group">
              <label>Password</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter your password"
                required
              />
            </div>
            <div className="form-group">
              <label>Password</label>
              <input
                type="password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                placeholder="Password (Again)"
                required
              />
            </div>
            <div
              className="form-group"
              style={{
                display: "flex",
                alignItems: "center",
                marginBottom: 20,
              }}
            >
              <input
                type="checkbox"
                id="acceptEmails"
                checked={acceptEmails}
                onChange={(e) => setAcceptEmails(e.target.checked)}
                style={{ marginRight: 8 }}
              />
              <label
                htmlFor="acceptEmails"
                style={{ margin: 0, fontWeight: 400 }}
              >
                I would like to receive emails about Neil Young Archives and
                Rust offers.
              </label>
            </div>
            {error && <p className="error">{error}</p>}
            <div className="confirmation-buttons aligned">
              <button
                className={`confirm-purchase`}
                onClick={(e) => {
                  if (!isFormValid) {
                    setError("Please fill out all fields to redeem the offer.");
                    e.preventDefault();
                    return;
                  }
                  handleSignUp(e);
                }}
              >
                Signup For FREE RUST!
              </button>
            </div>
          </div>
        ) : (
          <div className="form">
            <h3>Enter your email and we will be in touch to get you set up!</h3>

            <div className="form-group">
              <label>Email</label>
              <input
                type="currentEmail"
                value={email}
                onChange={(e) => setCurrentEmail(e.target.value)}
                placeholder="Enter your email"
                required
              />
            </div>
            <div className="form-group">
              <label>Concert Attended</label>
              <select
                className="concert-dropdown"
                value={selectedConcertAlready}
                onChange={(e) => setSelectedConcertAlready(e.target.value)}
                required
              >
                <option value="" disabled>
                  Select the concert you attended
                </option>
                {concertOptions.map((concert, idx) => (
                  <option key={idx} value={concert}>
                    {concert}
                  </option>
                ))}
              </select>
            </div>
            <div
              className="form-group"
              style={{
                display: "flex",
                alignItems: "center",
                marginBottom: 20,
              }}
            >
              <input
                type="checkbox"
                id="acceptEmails"
                checked={acceptEmailsAlready}
                onChange={(e) => setAcceptEmailsAlready(e.target.checked)}
                style={{ marginRight: 8 }}
              />
              <label
                htmlFor="acceptEmails"
                style={{ margin: 0, fontWeight: 400 }}
              >
                I would like to receive emails about Neil Young Archives and
                Rust offers.
              </label>
            </div>
            {error && <p className="error">{error}</p>}
            <div className="confirmation-buttons aligned">
              <button
                className={`confirm-purchase`}
                onClick={(e) => {
                  if (!isSecondFormValid) {
                    setError("Please fill out your email.");
                    e.preventDefault();
                    return;
                  }
                  sendEmailToDB(e);
                }}
              >
                Send
              </button>
            </div>
          </div>
        )}
      </div>
    );
  };

  const renderInitialContent = () => {
    if (isLoading) {
      return (
        <div className="rust-container">
          <div className="rust-signup-container">
            <div className="follow-description">
              <p>{loadingMessage}</p>
            </div>
            <img
              className="spinner loading"
              src={spinnerFrame01}
              alt="spinner"
              loading="lazy"
            />
          </div>
        </div>
      );
    }

    if (!promoIsAvailable) {
      return (
        <div className="rust-container">
          <div className="rust-signup-container">
            <img
              src={warning}
              alt="Warning Message"
              width="64px"
              loading="lazy"
            />
            <br />
            <br />
            <div className="follow-description">
              <p>This promo is not available at this time.</p>
            </div>
            <div className="confirmation-buttons aligned">
              <div
                className="confirm-purchase"
                onClick={() => (location.href = "/")}
              >
                CONTINUE
              </div>
            </div>
          </div>
        </div>
      );
    }

    if (freeTrialState === "Ok") {
      return (
        <div className="rust-container">
          <div className="rust-signup-container">
            <div className="follow-description">
              <p>
                Thank you for subscribing to{" "}
                <span style={{ fontFamily: "DinProBold" }}>NYA Rust</span> Plan.
              </p>
            </div>

            <br />
            <br />
            <img
              className="spinner loading"
              src={spinnerFrame01}
              alt="spinner"
              loading="lazy"
            />
            <div className="follow-description">
              <p>Reload in {countdown} seconds...</p>
            </div>
          </div>
        </div>
      );
    }

    return (
      <div className="rust-container">
        <div className="rust-signup-container">
          <div className="rust-header"></div>
          <div className="rust-free-message">
            <p>
              “Thanks for Being Part of the Music Tonight! Here’s a month of my
              Archives on me. All my songs in hi-res, movies, unreleased stuff –
              the works. – Neil”
            </p>
          </div>
          <div className="rust-description">
            <h3>NEIL YOUNG ARCHIVES MEMBERSHIP</h3>
            <p>FREE RUST - Enjoy One Month Free - No credit card required</p>

            <ul className="rust-features">
              <li>
                <span className="icon">
                  {/* Membership/Badge SVG */}
                  <svg
                    aria-hidden="true"
                    viewBox="0 0 512 512"
                    width="22"
                    height="22"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M256 0c-17.7 0-32 14.3-32 32v16.6C141.7 56.6 80 124.2 80 208c0 49.6 25.7 93.2 64.7 119.2l-24.8 99.2c-3.2 12.7 8.2 24.1 20.9 20.9l99.2-24.8c26 39 69.6 64.7 119.2 64.7 83.8 0 151.4-61.7 159.4-144H480c-17.7 0-32-14.3-32-32V32c0-17.7-14.3-32-32-32H256z" />
                  </svg>
                </span>
                Full Rust Membership
              </li>
              <li>
                <span className="icon">
                  {/* Headphones/Audio SVG */}
                  <svg
                    aria-hidden="true"
                    className="e-font-icon-svg e-fas-headphones-alt"
                    viewBox="0 0 512 512"
                    width="22"
                    height="22"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M160 288h-16c-35.35 0-64 28.7-64 64.12v63.76c0 35.41 28.65 64.12 64 64.12h16c17.67 0 32-14.36 32-32.06V320.06c0-17.71-14.33-32.06-32-32.06zm208 0h-16c-17.67 0-32 14.35-32 32.06v127.88c0 17.7 14.33 32.06 32 32.06h16c35.35 0 64-28.71 64-64.12v-63.76c0-35.41-28.65-64.12-64-64.12zM256 32C112.91 32 4.57 151.13 0 288v112c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16V288c0-114.67 93.33-207.8 208-207.82 114.67.02 208 93.15 208 207.82v112c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16V288C507.43 151.13 399.09 32 256 32z"></path>
                  </svg>
                </span>
                High-Resolution Audio
              </li>
              <li>
                <span className="icon">
                  {/* Film SVG */}
                  <svg
                    aria-hidden="true"
                    className="e-font-icon-svg e-fas-film"
                    viewBox="0 0 512 512"
                    width="22"
                    height="22"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M488 64h-8v20c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12V64H96v20c0 6.6-5.4 12-12 12H44c-6.6 0-12-5.4-12-12V64h-8C10.7 64 0 74.7 0 88v336c0 13.3 10.7 24 24 24h8v-20c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v20h320v-20c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v20h8c13.3 0 24-10.7 24-24V88c0-13.3-10.7-24-24-24zM96 372c0 6.6-5.4 12-12 12H44c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-96c0 6.6-5.4 12-12 12H44c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-96c0 6.6-5.4 12-12 12H44c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm272 208c0 6.6-5.4 12-12 12H156c-6.6 0-12-5.4-12-12v-96c0-6.6 5.4-12 12-12h200c6.6 0 12 5.4 12 12v96zm0-168c0 6.6-5.4 12-12 12H156c-6.6 0-12-5.4-12-12v-96c0-6.6 5.4-12 12-12h200c6.6 0 12 5.4 12 12v96zm112 152c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-96c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-96c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40z"></path>
                  </svg>
                </span>
                Concert Films and Rare Footage
              </li>
              <li>
                <span className="icon">
                  {/* Unlock SVG */}
                  <svg
                    aria-hidden="true"
                    className="e-font-icon-svg e-fas-unlock-alt"
                    viewBox="0 0 448 512"
                    width="22"
                    height="22"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M400 256H152V152.9c0-39.6 31.7-72.5 71.3-72.9 40-.4 72.7 32.1 72.7 72v16c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24v-16C376 68 307.5-.3 223.5 0 139.5.3 72 69.5 72 153.5V256H48c-26.5 0-48 21.5-48 48v160c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V304c0-26.5-21.5-48-48-48zM264 408c0 22.1-17.9 40-40 40s-40-17.9-40-40v-48c0-22.1 17.9-40 40-40s40 17.9 40 40v48z"></path>
                  </svg>
                </span>
                Unreleased Music
              </li>
              <li>
                <span className="icon">
                  {/* Newspaper SVG */}
                  <svg
                    aria-hidden="true"
                    className="e-font-icon-svg e-far-newspaper"
                    viewBox="0 0 576 512"
                    width="22"
                    height="22"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M552 64H112c-20.858 0-38.643 13.377-45.248 32H24c-13.255 0-24 10.745-24 24v272c0 30.928 25.072 56 56 56h496c13.255 0 24-10.745 24-24V88c0-13.255-10.745-24-24-24zM48 392V144h16v248c0 4.411-3.589 8-8 8s-8-3.589-8-8zm480 8H111.422c.374-2.614.578-5.283.578-8V112h416v288zM172 280h136c6.627 0 12-5.373 12-12v-96c0-6.627-5.373-12-12-12H172c-6.627 0-12 5.373-12 12v96c0 6.627 5.373 12 12 12zm28-80h80v40h-80v-40zm-40 140v-24c0-6.627 5.373-12 12-12h136c6.627 0 12 5.373 12 12v24c0 6.627-5.373 12-12 12H172c-6.627 0-12-5.373-12-12zm192 0v-24c0-6.627 5.373-12 12-12h104c6.627 0 12 5.373 12 12v24c0 6.627-5.373 12-12 12H364c-6.627 0-12-5.373-12-12zm0-144v-24c0-6.627 5.373-12 12-12h104c6.627 0 12 5.373 12 12v24c0 6.627-5.373 12-12 12H364c-6.627 0-12-5.373-12-12zm0 72v-24c0-6.627 5.373-12 12-12h104c6.627 0 12 5.373 12 12v24c0 6.627-5.373 12-12 12H364c-6.627 0-12-5.373-12-12z"></path>
                  </svg>
                </span>
                NYA Times-Contrarian
              </li>
              <li>
                <span className="icon">
                  {/* Envelope/Letter SVG */}
                  <svg
                    aria-hidden="true"
                    viewBox="0 0 512 512"
                    width="22"
                    height="22"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M502.3 190.8L327.4 338.3c-15.9 13.7-39.8 13.7-55.7 0L9.7 190.8C3.9 185.7 0 177.9 0 169.6V96c0-26.5 21.5-48 48-48h416c26.5 0 48 21.5 48 48v73.6c0 8.3-3.9 16.1-9.7 21.2zM464 80H48c-8.8 0-16 7.2-16 16v8.2l224 192 224-192V96c0-8.8-7.2-16-16-16zm48 113.6V416c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V193.6l218.5 187.2c27.6 23.6 68.4 23.6 96 0L512 193.6z" />
                  </svg>
                </span>
                Letters to Neil
              </li>
              <li>
                <span className="icon">
                  {/* Desktop SVG */}
                  <svg
                    aria-hidden="true"
                    viewBox="0 0 576 512"
                    width="22"
                    height="22"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M528 0H48C21.5 0 0 21.5 0 48v320c0 26.5 21.5 48 48 48h192v32h-64c-8.8 0-16 7.2-16 16s7.2 16 16 16h224c8.8 0 16-7.2 16-16s-7.2-16-16-16h-64v-32h192c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zm0 368H48V48h480v320z" />
                  </svg>
                </span>
                Desktop and Apps
              </li>
            </ul>

            <p>
              No credit card required. No Automatic Renewal. We'll invite you to
              subscribe if you wish to continue after 30 days.
            </p>
          </div>

          <div className="description-section">{renderSignInForm()}</div>
          <div className="follow-description">
            <p>What is the</p>
            <p>“Neil Young Archives?”</p>
            <p className="rust-p">
              “It’s my entire life’s work – every song, album, film, and video –
              all in one place, presented in the highest quality possible. A
              living library, constantly updated.”
            </p>
          </div>

          <div className="embed-player">
            <iframe
              title="Neil Young Archives"
              src="https://www.youtube.com/embed/t70V7lKLDUA"
              width="100%"
              height="400"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          </div>
          <div className="footer">
            <p>
              Please email us at RUST@NEILYOUNGARCHIVE.COM with any questions!
            </p>
            <div className="items-right">
              <a target="_blank" href="/privacy.html">
                PRIVACY POLICY
              </a>

              <span className="pipe">|</span>
              <a target="_blank" href="/terms.html">
                FREE RUST Rules
              </a>
              <span className="pipe">|</span>
              <a target="_blank" href={"/"}>
                NeilYoungArchives.com
              </a>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return <div className="main-rust-container">{renderInitialContent()}</div>;
};

export default FreeTrialRust;
